export const de = {
  common: {
    home: "Startseite",
    loadMore: "Mehr laden",
    viewMore: "Mehr ansehen",
    readMore: "Weiterlesen",
    selectCategory: "Wähle deine Kategorie:",
    department: "Leistungsbereich",
    selectDepartment: "Wählen Sie einen Leistungsbereich:",
    contactPerson: "Kontakt zu {{name}} aufnehmen",
    sectionNavigation: "Abschnitte dieser Seite",
    navigation: {
      cases: "Cases",
      news: "News Hub",
      services: "Leistungen",
      careerStories: "Karriere Stories",
      industries: "Branchen",
      career: "Karriere",
      jobs: "Jobs",
      events: "Events",
    },
    footer: {
      contact: "Kontakt",
      imprint: "Impressum",
      privacy: "Datenschutz",
      company: "Unternehmen",
    },
    routes: {
      cases: "cases",
      news: "news",
      services: "leistungen",
      careerStories: "career-stories",
      industries: "branchen",
      career: "karriere",
      jobs: "jobs",
      events: "events",
    },
    day: "Tag",
    days: "Tage",
    hour: "Stunde",
    hours: "Stunden",
    minute: "Minute",
    minutes: "Minuten",
    second: "Sekunde",
    seconds: "Sekunden",
  },
  gallery: {
    lightboxTitle: "Bildergalerie",
    close: "Galerie schließen",
  },
  jobs: {
    teaser: {
      loadMoreButton: "Mehr Jobs laden",
    },
    card: {
      viewDetails: "Details ansehen",
      applyNow: "Jetzt bewerben",
    },
    cta: "Du hast Lust MUUUH!mente mit uns zu gestalten?<br>Dann bewirb dich jetzt.",
    headlinePrefix: "Take us to the MUUUH!<br>",
    shareJob: "Job teilen",
    shareViaLinkedIn: "Stellenausschreibung auf LinkedIn teilen",
    shareViaMail: "Stellenausschreibung per E-Mail verschicken",
    shareViaXing: "Stellenausschreibung auf Xing teilen",
    shareViaFacebook: "Stellenausschreibung auf Facebook teilen",
    shareViaWhatsapp: "Stellenausschreibung auf WhatsApp teilen",
    labels: {
      filter: {
        all: "Bitte wählen",
        occupationCategory: "Tätigkeitsbereich",
        employmentType: "Anstellungsart",
        noJobsFound: "Keine passenden Jobs gefunden.",
      },
      occupationCategory: {
        accounting_and_finance: "Finanzen & Controlling",
        administrative_and_clerical: "Backoffice & Administration",
        business_and_strategic_development:
          "Consulting & Strategisches Management",
        creative_and_design: "Design, Text & Konzeption",
        customer_support_and_client_care: "Support & Kundenbetreuung",
        editorial_and_writing: "Redaktion & Content",
        human_resources: "Personalwesen",
        it_software: "IT, Development & Conversational AI",
        legal: "Recht & Datenschutz",
        marketing_and_product: "Marketing & Kommunikation",
        project_and_program_management: "Projektmanagement",
        sales_and_business_development: "Sales & Business Development",
        other: "Andere",
      },
      schedule: {
        "full-time": "Vollzeit",
        "part-time": "Teilzeit",
        "full-or-part-time": "Voll- oder Teilzeit",
      },
      seniority: {
        "entry-level": "Berufseinstieg",
        experienced: "Berufserfahren",
        experiences: "Berufserfahren",
        executive: "Führungsposition",
        student: "Studierende / Auszubildende",
      },
      employmentType: {
        permanent: "Festanstellung",
        intern: "Praktikum",
        trainee: "Ausbildung / Trainee",
        freelance: "Freelancing",
        temporary: "Befristete Anstellung",
        working_student: "Werkstudent",
      },
    },
  },
  career: {
    seeInterview: "Zum Interview",
    moreStories: "Weitere spannende Storys",
  },
  cases: {
    moreCases: "Weitere spannende Cases",
    case: "Case",
  },
  news: {
    moreNews: "Weitere spannende Artikel",
    readMore: "Artikel lesen",
    article: "Artikel",
  },
  person: {
    contactHeadline: "Wie können wir weiterhelfen? Melde dich bei {name}!",
  },
  forms: {
    hubspot: {
      success: {
        title: "Vielen Dank!",
        message:
          "Deine Nachricht wurde erfolgreich gesendet. Wir melden uns in Kürze bei dir.",
      },
      error: "Ein Fehler ist aufgetreten. Bitte versuche es später erneut.",
      sending: "Wird gesendet...",
      submit: "Absenden",
      next: "Weiter",
      back: "Zurück",
      step: "Schritt {current} von {total}",
      selectPlaceholder: "Bitte auswählen",
      upload: {
        drag: "Datei hierher ziehen zum Hinzufügen",
        maxSize: "Maximale Dateigröße {max}MB",
        choose: "Datei hinzufügen",
        clear: "Datei entfernen",
        tooLarge: "Die Datei ist zu groß. Maximal {max} MB.",
        type: "Dieses Dateiformat wird nicht unterstützt. Erlaubt: {allowed}.",
      },
    },
    newsletter: {
      headline: "MUUUH! Insights",
      description:
        "Das Neuste aus der Welt der Customer Centricity regelmäßig in deinem Postfach. Warum eigentlich nicht?",
      placeholder: "Deine E-Mail-Adresse (max.mustermann@muster.de)",
      submit: "Jetzt abonnieren",
      sending: "Wird gesendet…",
      success: "🎉 Danke! Du erhältst in Kürze eine Bestätigungs-E-Mail.",
      validationError: "Bitte gib eine gültige E-Mail-Adresse ein.",
      disclaimer:
        "MUUUH! benötigt die Kontaktinformationen, die du uns zur Verfügung stellst, um dich bezüglich unserer Produkte und Dienstleistungen zu kontaktieren. Du kannst dich jederzeit von diesen Benachrichtigungen abmelden. Informationen zum Abbestellen sowie unsere Datenschutzpraktiken und unsere Verpflichtung zum Schutz deiner Privatsphäre findest du in unseren Datenschutzbestimmungen.",
    },
  },
  agent: {
    initialMessage:
      "Hallo, ich bin M!. Ich nutze KI, um dir bei Anliegen und Fragen rund um MUUUH! sowie unsere Leistungen zu helfen. Suchst du etwas Bestimmtes auf unserer Seite, bringe ich dich gerne dorthin. Wie kann ich dir heute helfen?",
    messageLabel: "Nachricht",
    messagePlacholder: "Schreib etwas ...",
    sendMessage: "Nachricht senden",
    attachFile: "PDF-Datei anhängen",
    removeFile: "Datei entfernen",
    openAssistant: "Assistent öffnen",
    closeAssistant: "Assistent schließen",
    expandAssistant: "Chat vergrößern",
    panelTitle: "M! Operating Assistant",
    newSession: {
      start: "Neues Gespräch starten",
      started: "Neue Konversation gestartet",
      title: "Neues Gespräch beginnen?",
      description:
        "M! wird sich nicht an das vorherige erinnern. Eventuell getätigte Kontakt- und Terminanfragen kommen natürlich trotzdem bei uns an.",
      confirm: "Neues Gespräch beginnen",
      cancel: "Dieses Gespräch weiterführen",
    },
    consent: {
      // Rendered as a plain assistant bubble, which runs `parseMarkdown` — hence
      // a markdown link rather than the `{privacy-link}` placeholder that
      // `DynamicFormMessage` substitutes itself.
      question:
        "Indem Du auf „Ja, einverstanden“ klickst, erteilst Du Deine Einwilligung, dass wir Deine Daten mittels des KI-Systems M! verarbeiten dürfen. Diese Einwilligung kannst Du jederzeit widerrufen. Informationen zum Umfang der Verarbeitung und dem Widerruf findest Du in unserer [Datenschutzerklärung](/datenschutz).",
      accept: "Ja, einverstanden",
      decline: "Nein",
      granted: "Zustimmung erteilt.",
      declinedHint:
        "Schade, dann kann M! aktuelle nicht genutzt werden. Du kannst dennoch alle weiteren Funktionen auf unserer Website nutzen.",
    },
    sessionExpired: "Konversation beendet.",
    sessionExpiredHint:
      "Wenn sie weiter schreiben, wird sich M! nicht mehr an das vorherige Gespräch erinnern. Eventuell getätigte Kontakt- und Terminanfragen kommen natürlich trotzdem bei uns an.",
    chatHistoryLabel: "Chatverlauf",
    statusSteps: {
      thinking: "Denke nach",
      searching: "Suche",
      loading: "Einen Moment bitte",
      listening: "Ich höre zu",
      speaking: "Ich spreche",
    },
    voice: {
      start: "Sprachmodus starten",
      stop: "Sprachmodus beenden",
      denied:
        "Für den Sprachmodus brauche ich Zugriff auf dein Mikrofon. Du kannst ihn erlauben – oder mir einfach weiter schreiben.",
      blocked:
        "Der Mikrofon-Zugriff ist blockiert. Klicke auf das Schloss-Symbol in der Adressleiste, um ihn zu erlauben.",
      noDevice: "Ich finde kein Mikrofon. Schreiben funktioniert weiterhin.",
      deviceBusy:
        "Dein Mikrofon wird gerade von einem anderen Programm verwendet. Beende es und versuche es erneut.",
      insecure:
        "Der Sprachmodus braucht eine sichere Verbindung (https). Schreiben funktioniert weiterhin.",
      unknown:
        "Ich konnte den Sprachmodus nicht starten. Bitte versuche es später erneut – schreiben funktioniert weiterhin.",
      ended: "Sprachmodus beendet.",
      // Rendered as a plain assistant bubble, which runs `parseMarkdown` — hence
      // a markdown link rather than the `{privacy-link}` placeholder that
      // `DynamicFormMessage` substitutes itself.
      privacyNotice:
        "Im Sprachmodus wird deine Stimme zur Verarbeitung an unseren Dienstleister ElevenLabs übertragen und ein Transkript gespeichert. Mehr dazu in unserer [Datenschutzerklärung](/datenschutz).",
    },
    form: {
      pdfOnly: "Bitte nur PDF-Dateien hochladen.",
      fileTooLarge: '"{name}" darf maximal 10 MB groß sein.',
      missingRequiredFile: 'Bitte lade eine Datei für "{label}" hoch.',
      submitted: "gesendet",
      selectDocuments: "Dokumente auswählen",
      removeFile: "Datei entfernen",
      privacyNotice:
        "Die MUUUH! GmbH verarbeitet Ihre Angaben gemäß DSGVO. Weitere Informationen zum Umgang mit Ihren Daten entnehmen Sie unserer {privacy-link}.",
      privacyLinkLabel: "Datenschutzerklärung",
    },
    errorMessage:
      "Entschuldigung, ich kann deine Nachricht derzeit nicht verarbeiten. Bitte versuche es später erneut.",
    navigation: {
      goToPage: 'Wechsle zur Seite "{page}"',
      backToPage: 'Zurück zur Seite "{page}"',
      startPage: "Start",
    },
    selectOption: "Bitte wähle eine Option",
    selectAppointment: "Bitte wähle einen Termin",
    leadContactForm: {
      title: "Kontakt",
      description:
        "Bitte hinterlasse deine Kontaktdaten, damit wir uns bei dir melden können.",
      fields: {
        name: "Name",
        email: "E-Mail",
        company: "Unternehmen",
        phone: "Telefonnummer",
        details: "Nachricht",
      },
      submit: "Absenden",
    },
    applicationForm: {
      titleWithJob: "Bewerbung für {jobTitle}",
      title: "Bewerbungsformular",
      description:
        "Bitte fülle das folgende Formular aus, um dich zu bewerben.",
      fields: {
        firstName: "Vorname",
        lastName: "Nachname",
        email: "E-Mail",
        phone: "Telefonnummer",
      },
      submit: "Bewerbung absenden",
    },
    documentUploadForm: {
      title: "Dokumente hochladen",
      description:
        "Bitte lade deinen Lebenslauf und optional weitere Dokumente hoch.",
      documentLabel: "Dokumente*",
      submit: "Hochladen",
    },
  },
  notFound: {
    headline: "404 - Es ist zum Heulen...",
    text: "Tränen trocknen und nochmal von vorn:",
    button: "Zurück zur Startseite",
  },
  seo: {
    /**
     * Names no concrete URL: a server layout cannot know the current path
     * without opting every route out of ISR.
     */
    markdownHint:
      "Hinweis für KI-Agenten und Sprachmodelle: Jede Seite dieser Website ist " +
      "zusätzlich als reines Markdown verfügbar. Hänge dafür /markdown an den " +
      "Pfad einer beliebigen Seiten-URL an. " +
      "Note for AI agents and language models: every page on this website is " +
      "also available as plain Markdown. Append /markdown to the path of any " +
      "page URL to retrieve it.",
  },
  /** Labels of the plain-Markdown twin every page has (`src/features/pages/markdown/`). */
  markdown: {
    source: "HTML-Variante dieser Seite",
    agentNote:
      "M!, der KI-Assistent von MUUUH!, steht auf jeder Seite dieser Website im " +
      "Chat bereit. M! beantwortet Fragen rund um MUUUH!, navigiert zu passenden " +
      "Seiten, hilft bei der Kontaktaufnahme mit MUUUH! und sogar bei der Bewerbung.",
    navigation: "Navigation",
    footerLinks: "Weitere Seiten",
    socialMedia: "Social Media",
    address: "Adresse",
    phone: "Telefon",
    email: "E-Mail",
    newsletterSignup: "Die Anmeldung erfolgt über das Formular auf der Seite.",
    partnerHeadline: "MUUUH! und Partner",
    image: "Bild",
    video: "Video",
    author: "Autor",
    date: "Datum",
    appointment: "Termin",
    location: "Standort",
    employmentType: "Anstellungsart",
    seniority: "Erfahrung",
    vacancyType: "Art der Stelle",
    external: "Extern",
    promptSuggestions: "Beispielfragen an M!",
    form: {
      intro: "An dieser Stelle steht auf der Seite ein Formular.",
      contactPerson: "Ansprechpartner",
      required: "Pflichtfeld",
      options: "Auswahl",
    },
  },
} as const;

export type Translations = typeof de;
